import search from "./instantsearch";
import widgets from "./widgets";
import config from "./config";

if (config.container) {
  search.addWidgets(widgets);

  search.start();
}
